import { Axios } from '../api';
import { REGISTERS_API_URL } from '../constants';
import { type AppDatabase } from '../db';
import type { Docket } from '../models';
import { toBooleanValueFields } from '../transform';
import { BOOLEAN_VALUE } from '../types';
import type { MappedDocketResponse } from '../types/docket';

export class DocketService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async fetchAndBulkUpsert() {
        const response = await Axios.get<MappedDocketResponse[]>(
            REGISTERS_API_URL.REGISTER.DOCKETS,
        );

        await this.bulkUpsert(response.data);
    }

    async getById(id: string) {
        return this.db.dockets
            .where('[id+deleted]')
            .equals([id, BOOLEAN_VALUE.FALSE])
            .first();
    }

    async getActive() {
        return this.db.dockets
            .where('deleted')
            .equals(BOOLEAN_VALUE.FALSE)
            .toArray();
    }

    async getAll() {
        return this.db.dockets.toArray();
    }

    private async bulkUpsert(dockets: MappedDocketResponse[]) {
        const output = dockets.map((docket) =>
            toBooleanValueFields(docket, ['deleted']),
        );

        await this.db.dockets.clear();
        await this.db.dockets.bulkPut(output as unknown as Docket[]);
    }
}
